import {
  SET_DASHBOARD_DATA,
  SET_DASHBOARD_LOADING,
  SET_DASHBOARD_ERROR,
  SET_SELLER_TICKET_COUNT,
  SET_N11_TICKET_COUNT,
} from "./mutation-types";

export default {
  [SET_DASHBOARD_DATA](state, data) {
    state.dashboardData = data;
  },

  [SET_DASHBOARD_LOADING](state, loading) {
    state.dashboardLoading = loading;
  },

  [SET_DASHBOARD_ERROR](state, error) {
    state.dashboardError = error;
  },
  [SET_SELLER_TICKET_COUNT](state, payload) {
    state.sellerTicketCount = payload;
  },
  [SET_N11_TICKET_COUNT](state, payload) {
    state.n11TicketCount = payload;
  },
};
